import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const LanguageArtsLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(4 35) rotate(-6)"
    >
      <linearGradient
        id="SVGID_6_"
        x1="487.929"
        x2="555.452"
        y1="108.183"
        y2="108.183"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_6_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(84 35) rotate(-6)"
    >
      <linearGradient
        id="SVGID_6_"
        x1="487.929"
        x2="555.452"
        y1="108.183"
        y2="108.183"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_6_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(169 25) rotate(2)"
    >
      <linearGradient
        id="SVGID_6_"
        x1="487.929"
        x2="555.452"
        y1="108.183"
        y2="108.183"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_6_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(-25 -37) rotate(-16)"
    >
      <linearGradient
        id="SVGID_6_"
        x1="487.929"
        x2="555.452"
        y1="108.183"
        y2="108.183"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_6_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(63 -45) rotate(-6)"
    >
      <linearGradient
        id="SVGID_6_"
        x1="487.929"
        x2="555.452"
        y1="108.183"
        y2="108.183"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_6_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(153 -55) rotate(6)"
    >
      <linearGradient
        id="SVGID_6_"
        x1="487.929"
        x2="555.452"
        y1="108.183"
        y2="108.183"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_6_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g
      className="digital-resources-language-art"
      transform="translate(420, 70)"
    >
      <defs>
        <radialGradient
          id="b820efa6-46e9-47b4-99e3-b3251c2375d7"
          data-name="grad-35"
          cx="252.32"
          cy="321.5"
          r="69"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#00ff78" />
          <stop offset="0.1" stopColor="#00ff7b" stopOpacity="0.98" />
          <stop offset="0.22" stopColor="#00ff84" stopOpacity="0.91" />
          <stop offset="0.36" stopColor="#00ff92" stopOpacity="0.81" />
          <stop offset="0.51" stopColor="#00ffa6" stopOpacity="0.66" />
          <stop offset="0.68" stopColor="#00ffc0" stopOpacity="0.47" />
          <stop offset="0.84" stopColor="#00ffdf" stopOpacity="0.24" />
          <stop offset="1" stopColor="aqua" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="a06df8d4-299d-4a42-ad89-eeeacef31b78"
          cx="252.32"
          r="69.5"
          xlinkHref="#b820efa6-46e9-47b4-99e3-b3251c2375d7"
        />
        <radialGradient
          id="f23fca45-a36c-49c7-8a89-03ec36ef30f1"
          data-name="grad-2"
          cx="415.33"
          cy="118.8"
          r="3"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0.3" />
          <stop offset="0.51" stopColor="#7fff7f" stopOpacity="0.65" />
          <stop offset="1" stopColor="lime" />
        </radialGradient>
        <radialGradient
          id="e2a1374e-ec02-43e7-a8b1-5ef6676e838e"
          data-name="grad-3"
          cx="406.96"
          cy="120.13"
          r="2.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0.5" />
          <stop offset="0.13" stopColor="#f7d1df" stopOpacity="0.6" />
          <stop offset="0.38" stopColor="#e87fa5" stopOpacity="0.77" />
          <stop offset="0.62" stopColor="#dd447c" stopOpacity="0.9" />
          <stop offset="0.84" stopColor="#d62163" stopOpacity="0.97" />
          <stop offset="1" stopColor="#d4145a" />
        </radialGradient>
        <radialGradient
          id="b18dac75-3b4f-43e5-86a2-f60df46c4fea"
          data-name="grad-62"
          cx="393.76"
          cy="438.72"
          r="18.13"
          gradientTransform="matrix(-0.03, -1.64, 1.14, -0.05, -93.87, 781.34)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#d4145a" />
          <stop offset="0.32" stopColor="#d82c54" stopOpacity="0.91" />
          <stop offset="0.54" stopColor="#e46944" stopOpacity="0.69" />
          <stop offset="0.85" stopColor="#f6cc2a" stopOpacity="0.33" />
          <stop offset="0.95" stopColor="#fcee21" stopOpacity="0.2" />
        </radialGradient>
        <radialGradient
          id="b9c0f194-cd34-4afc-bbe3-9b597dc8850e"
          cx="364.15"
          cy="459.48"
          r="13.66"
          gradientTransform="matrix(-1.3, -0.18, 0.06, -1.01, 836.76, 624.35)"
          xlinkHref="#b18dac75-3b4f-43e5-86a2-f60df46c4fea"
        />
      </defs>
      <g id="f6f52cfa-bfc9-44c7-b719-48cbbabc27fc" data-name="lang">
        <path
          d="M325,321.51s-14.51-22.71-15.77-4.41,18.92,63.7-6.31,84.52c0,0,6.31-26.49-7.57-27.12-12.76-.58-33,65-34.69,85.85-1.68-20.82-21.92-86.43-34.69-85.85-13.88.63-7.57,27.12-7.57,27.12-25.23-20.82-5.05-66.23-6.31-84.52s-15.77,4.41-15.77,4.41c-3.78-30.28,15.77-51.09,15.77-51.09l27.13-.63,8.83,12h27.75l8.83-11.35h24.6S328.75,291.23,325,321.51Z"
          fill="#e7f4f7"
        />
        <path
          d="M319.28,305.74s-17.44-9.36-18.48,5.77,26.74,47.66,5.87,64.88c0,0-5.87-16.88-17.35-17.4-10.56-.48-27.3,53.79-28.7,71-1.39-17.22-18.13-71.49-28.69-71-11.48.52-13.57,12.35-13.57,12.35-20.87-17.21,3.13-44.7,2.09-59.83S202,305.74,202,305.74c-3.13-25,18.49-32.84,18.49-32.84l18.73-3.11,11,12.5h22.95l11.45-8.72,16.21-.67S322.41,280.7,319.28,305.74Z"
          fill="#a6e4f4"
        />
        <path
          d="M304.31,295s-13-7-13.75,4.29,19.89,35.45,4.37,48.26c0,0-4.37-12.55-12.91-12.94-7.85-.36-20.31,40-21.34,52.83-1-12.82-13.49-53.19-21.35-52.83-8.54.39-10.09,9.19-10.09,9.19-15.53-12.81,2.33-33.25,1.55-44.51S217,295,217,295c-2.33-18.63,13.75-24.43,13.75-24.43l17.27,11.53,4.85-4.54H270l5.83,4.54,14.74-11.53S306.64,276.35,304.31,295Z"
          fill="#425cad"
        />
        <path
          d="M286.4,289.43s-7.66-5.05-8.12,3.12,11.75,25.72,2.58,35c0,0-2.58-9.11-7.62-9.4-4.63-.25-12,29-12.6,38.34-.61-9.3-8-38.59-12.6-38.34-5,.29-6,6.67-6,6.67-9.16-9.29,1.38-24.13.92-32.29s-8.12-3.12-8.12-3.12c-1.37-13.52,4.35-19.34,4.35-19.34l11.35,12.62,5.48-5.94h10.08l5.26,9.09,15.14-11.35S287.78,275.91,286.4,289.43Z"
          fill="#e7f4f7"
        />
        <path
          d="M284.65,240.45v33.18s15.13,11.91,27.75,0V240.45Z"
          fill="#6e7582"
        />
        <path
          d="M211.48,245.49v24.6s15.14,8.83,27.75,0v-24.6Z"
          fill="#6e7582"
        />
        <path
          d="M248.06,249.28v33.18s15.14,11.91,27.76,0V249.28Z"
          fill="#6e7582"
        />
        <path
          d="M284.65,240.45V263c9.38-1.12,19.55-3,27.75-11.23l-.13-11.35Z"
          fill="#152b4c"
          opacity="0.38"
        />
        <path
          d="M275.82,263.81V249.28H248.06v13.84A27.31,27.31,0,0,0,275.82,263.81Z"
          fill="#152b4c"
          opacity="0.38"
        />
        <path
          d="M239.23,245.49H211.52l0,6.31a40.27,40.27,0,0,0,27.75,10.26Z"
          fill="#152b4c"
          opacity="0.38"
        />
        <path
          d="M211.56,224.05l-.08,21.44s56.77,17.66,100.92,0l-.17-20.81Z"
          fill="#6e7582"
        />
        <path
          d="M312.4,245.49l-.17-20.81-15.41-.1L258.6,230.3s-14.32,20.87-47.12,15.19C211.48,245.49,268.25,263.15,312.4,245.49Z"
          fill="#1e3b68"
          opacity="0.38"
        />
        <path
          d="M260.68,230.35c121.1,1.9,146.34-90.2,146.34-90.2H113.71S139.57,228.46,260.68,230.35Z"
          fill="#bb8082"
        />
        <path
          d="M399.74,157.33c-5.14-5.62-11-11.5-11.65-11.5-1.26,0-21.44,15.14-21.44,15.14s-82,21.45-141.93,18.92c0,0,88.94,8.83,65,29.65A155.43,155.43,0,0,1,258.6,230.3l2.08,0C348.32,231.72,385.75,183.87,399.74,157.33Z"
          fill="#6e7582"
        />
        <path
          d="M115.45,144.94c7.43,18.37,41.05,83.46,144.48,85.39-82.88-13.2-99.9-78.22-102.35-90.18H144.74C135.69,141.55,123.66,143.45,115.45,144.94Z"
          fill="#f39189"
          opacity="0.48"
        />
        <path
          d="M150,192.37c30.3,8.58,69.46,13.76,112.22,13.76,41.63,0,79.84-4.91,109.8-13.08,27.27-24.83,35-52.9,35-52.9H113.71S121.79,167.71,150,192.37Z"
          fill="#1e3b68"
          opacity="0.38"
        />
        <ellipse
          cx="260.36"
          cy="140.15"
          rx="174.09"
          ry="58.41"
          fill="#3b7257"
          stroke="#6ef4ed"
          strokeMiterlimit="10"
          strokeWidth="4.31"
        />
        <ellipse
          cx="260.36"
          cy="140.15"
          rx="107.46"
          ry="36.05"
          fill="#f7c8b2"
        />
        <path
          d="M434.32,114.15a20.49,20.49,0,0,1-4.58,12.39c-18-25.82-87-45-169.42-45s-151.41,19.22-169.42,45a20.49,20.49,0,0,1-4.58-12.39c0-29.9,77.9-54.15,174-54.15S434.32,84.25,434.32,114.15Z"
          fill="#88bfe2"
          opacity="0.26"
        />
        <path
          d="M429.74,126.54c-18,23.94-87,41.77-169.42,41.77S108.9,150.48,90.9,126.54c18-25.82,87-45,169.42-45S411.73,100.72,429.74,126.54Z"
          fill="none"
          stroke="#88bfe2"
          strokeMiterlimit="10"
          strokeWidth="1.04"
        />
        <path
          d="M167.48,205.33c21.77,13.68,51.73,24.26,92.56,25h7.77c37.78-.57,65.77-10.5,86.32-23.59-26,4.76-56.72,7.52-89.67,7.52C228.36,214.27,194.92,211,167.48,205.33Z"
          fill="#1e3b68"
          opacity="0.38"
        />
        <line
          x1="434.45"
          y1="139.84"
          x2="512.82"
          y2="139.5"
          fill="#046582"
          stroke="#6ef4ed"
          strokeMiterlimit="10"
          strokeWidth="0.66"
        />
        <line
          x1="86.27"
          y1="139.84"
          x2="5.82"
          y2="139.5"
          fill="#046582"
          stroke="#6ef4ed"
          strokeMiterlimit="10"
          strokeWidth="0.66"
        />
        <line
          x1="260.36"
          y1="81.81"
          x2="260.32"
          y2="39"
          fill="none"
          stroke="#62ccc4"
          strokeMiterlimit="10"
          strokeWidth="0.66"
        />
        <line
          x1="261.62"
          y1="198.5"
          x2="261.32"
          y2="239"
          fill="#046582"
          stroke="#6ef4ed"
          strokeMiterlimit="10"
          strokeWidth="0.66"
        />
        <circle cx="260.73" cy="38.99" r="5.99" fill="#62ccc4" />
        <circle cx="261.99" cy="239.21" r="5.99" fill="#6ef4ed" />
        <circle cx="5.99" cy="139.21" r="5.99" fill="#6ef4ed" />
        <circle cx="512.99" cy="140.21" r="5.99" fill="#6ef4ed" />
        <path
          d="M224.72,226.94l-13.16-2.89-.08,21.44C215.89,231,224.72,226.94,224.72,226.94Z"
          fill="#f39189"
          opacity="0.48"
        />
        <path
          d="M198.82,506.5c0,1.93-4.06,3.5-14,3.5s-22-4.07-22-6,9.06,3,19,3S198.82,504.57,198.82,506.5Z"
          fill="#1e3b68"
          opacity="0.38"
        />
        <g>
          <path
            d="M347,47.89v4.34h-.6c-.34,0-.61-1-.61-2.17s.27-2.17.61-2.17h.6Z"
            fill="#ccbe9e"
          />
          <ellipse cx="347" cy="50.06" rx="0.61" ry="2.17" fill="#3a7599" />
          <path
            d="M349.46,48.85l-.22,2.43h-2.05c-.16,0-.28-.55-.28-1.22s.12-1.21.28-1.21h2.27Z"
            fill="#295566"
          />
          <path
            d="M347.67,48.6a2.31,2.31,0,0,0,0,2.93h1.53a3.54,3.54,0,0,1,0-2.93Z"
            fill="#3a7599"
          />
          <path
            d="M347.67,51.53s1.47,15.9,10.21,16S368,51.09,368,51.09h-1.4S363.63,66,357.88,65.83s-8.68-14.3-8.68-14.3Z"
            fill="#3a7599"
          />
          <path
            d="M351.31,43.23s4.53-3.44,12.32-.76c0,0,2.81,3.57,2.81,7.21s-4,13.79-8.56,14-8.68-10.4-8.68-13.34A11.82,11.82,0,0,1,351.31,43.23Z"
            fill="#33667f"
          />
          <circle cx="357.82" cy="50.38" r="8.36" fill="#295566" />
          <circle cx="357.82" cy="50.38" r="7.91" fill="#90a5b7" />
          <circle
            cx="354.76"
            cy="46.49"
            r="1.66"
            fill="#33667f"
            opacity="0.51"
          />
          <circle
            cx="361.71"
            cy="46.49"
            r="1.66"
            fill="#33667f"
            opacity="0.51"
          />
          <circle cx="354.57" cy="46.49" r="1.66" fill="#2f506a" />
          <path
            d="M352.91,46.49a1.66,1.66,0,0,1,3.32,0"
            fill="none"
            stroke="#20323f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.45"
          />
          <circle cx="354.57" cy="46.49" r="1.15" fill="#20323f" />
          <circle cx="361.52" cy="46.49" r="1.15" fill="#20323f" />
          <circle cx="361.52" cy="46.49" r="1.66" fill="#275474" />
          <path
            d="M348.18,48.6s.64,1.85-1,1.78a2.89,2.89,0,0,0,.48,1.15h1.53a3.54,3.54,0,0,1,0-2.93Z"
            fill="#33667f"
          />
          <path
            d="M346.33,47.92a3.16,3.16,0,0,0-.51,2.14v.22c.11-.33.3-.65.58-.45,0,0,.06-1.74.57-1.94h-.6Z"
            fill="#f9e9ca"
          />
          <path
            d="M368.61,47.51v4.34h.6c.34,0,.61-1,.61-2.17s-.27-2.17-.61-2.17h-.6Z"
            fill="#ccbe9e"
          />
          <ellipse cx="368.64" cy="49.68" rx="0.61" ry="2.17" fill="#3a7599" />
          <path
            d="M366.18,48.47l.22,2.42h2.05c.16,0,.29-.54.29-1.21s-.13-1.21-.29-1.21h-2.27Z"
            fill="#295566"
          />
          <path
            d="M368,48.21a2.33,2.33,0,0,1,0,2.94h-1.53a3.56,3.56,0,0,0,0-2.94Z"
            fill="#3a7599"
          />
          <path
            d="M369.32,47.54a3.22,3.22,0,0,1,.5,2.14v.21c-.11-.32-.29-.64-.57-.44,0,0-.07-1.75-.58-1.94h.6Z"
            fill="#f9e9ca"
          />
          <path
            d="M366.73,50.13h0a4.75,4.75,0,0,1-.29,1H368a2.33,2.33,0,0,0,0-2.94h-.51S368.23,50.08,366.73,50.13Z"
            fill="#33667f"
          />
          <path
            d="M357.88,66.53c5.1,0,8.8-11.25,10.08-15.36v0l-1.4,0c-.13.66-3.07,14.84-8.68,14.72s-8.68-14.3-8.68-14.3h-1.53a10.72,10.72,0,0,1,1.79,3.64C350.16,57.53,352.78,66.53,357.88,66.53Z"
            fill="#33667f"
          />
          <g>
            <path
              d="M353,65.45h0l.45.41C353.56,65.86,353.44,65.74,353,65.45Z"
              fill="#f9e9ca"
              opacity="0.25"
            />
            <path
              d="M348,53.83c.52,2.87,1.73,7.77,4.34,10.87-1.75-2.53-2.87-9.11-4.34-10.87Z"
              fill="#f9e9ca"
              opacity="0.25"
            />
          </g>
          <path
            d="M350.3,45c.31-.27.66-.58,1-.92a15.68,15.68,0,0,1,4.23-2.42,10.3,10.3,0,0,0-4.23,1.59A8.06,8.06,0,0,0,350.3,45Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
          <path
            d="M356.65,63.53c-1.88-1.48-5.89-7.56-5.89-7.56h0C352.14,59.22,354.29,62.68,356.65,63.53Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
          <circle cx="361.52" cy="46.49" r="1.15" fill="#20323f" />
          <path
            d="M359.86,46.49a1.66,1.66,0,0,1,3.32,0"
            fill="none"
            stroke="#20323f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.45"
          />
          <path
            d="M357.92,94.87h0a2,2,0,0,1-2-2V67.52c0-1.1.93-1,2-1h0c1.1,0,2-.11,2,1V92.86A2,2,0,0,1,357.92,94.87Z"
            fill="#3a7599"
          />
          <g>
            <path
              d="M356.54,92.86V67.52c0-.83-.63-1-.63,0V92.86a2,2,0,0,0,2,2h0l.32,0A2,2,0,0,1,356.54,92.86Z"
              fill="#f9e9ca"
              opacity="0.25"
            />
            <path d="M358.59,66.53Z" fill="#f9e9ca" opacity="0.25" />
          </g>
          <path
            d="M359.23,93V67.65c0-.83.63-1.05.63,0V93a2,2,0,0,1-2,2h0a1.73,1.73,0,0,1-.32,0A2,2,0,0,0,359.23,93Z"
            fill="#33667f"
            opacity="0.61"
          />
        </g>
        <g transform="translate(85 -104)">
          <path
            d="M169,141.89v4.34h-.6c-.34,0-.61-1-.61-2.17s.27-2.17.61-2.17h.6Z"
            fill="#ccbe9e"
          />
          <ellipse cx="169" cy="144.06" rx="0.61" ry="2.17" fill="#3a7599" />
          <path
            d="M171.46,142.85l-.22,2.43h-2.05c-.16,0-.28-.55-.28-1.22s.12-1.21.28-1.21h2.27Z"
            fill="#295566"
          />
          <path
            d="M169.67,142.6a2.31,2.31,0,0,0,0,2.93h1.53a3.54,3.54,0,0,1,0-2.93Z"
            fill="#3a7599"
          />
          <path
            d="M169.67,145.53s1.47,15.9,10.21,16S190,145.09,190,145.09h-1.4s-2.94,14.87-8.69,14.74-8.68-14.3-8.68-14.3Z"
            fill="#3a7599"
          />
          <path
            d="M173.31,137.23s4.53-3.44,12.32-.76c0,0,2.81,3.57,2.81,7.21s-4,13.79-8.56,14-8.68-10.4-8.68-13.34A11.82,11.82,0,0,1,173.31,137.23Z"
            fill="#33667f"
          />
          <circle cx="179.82" cy="144.38" r="8.36" fill="#295566" />
          <circle cx="179.82" cy="144.38" r="7.91" fill="#90a5b7" />
          <circle
            cx="176.76"
            cy="140.49"
            r="1.66"
            fill="#33667f"
            opacity="0.51"
          />
          <circle
            cx="183.71"
            cy="140.49"
            r="1.66"
            fill="#33667f"
            opacity="0.51"
          />
          <circle cx="176.57" cy="140.49" r="1.66" fill="#2f506a" />
          <path
            d="M174.91,140.49a1.66,1.66,0,0,1,3.32,0"
            fill="none"
            stroke="#20323f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.45"
          />
          <circle cx="176.57" cy="140.49" r="1.15" fill="#20323f" />
          <path
            d="M179.76,147.83a.48.48,0,0,1-.46-.39c-.17-1.07-.5-3.95.9-3.95s1.25,2.83,1.14,3.92a.47.47,0,0,1-.46.42Z"
            fill="#33667f"
            opacity="0.51"
          />
          <circle cx="183.52" cy="140.49" r="1.15" fill="#20323f" />
          <circle cx="183.52" cy="140.49" r="1.66" fill="#275474" />
          <path
            d="M179.38,147.83a.47.47,0,0,1-.46-.39c-.17-1.07-.5-3.95.9-3.95s1.24,2.83,1.14,3.92a.48.48,0,0,1-.47.42Z"
            fill="#2f506a"
          />
          <circle cx="179.82" cy="144.38" r="0.89" fill="#38607a" />
          <circle cx="179.82" cy="144.38" r="0.7" fill="#20323f" />
          <path
            d="M170.18,142.6s.64,1.85-1,1.78a2.89,2.89,0,0,0,.48,1.15h1.53a3.54,3.54,0,0,1,0-2.93Z"
            fill="#33667f"
          />
          <path
            d="M168.33,141.92a3.16,3.16,0,0,0-.51,2.14v.22c.11-.33.3-.65.58-.45,0,0,.06-1.74.57-1.94h-.6Z"
            fill="#f9e9ca"
          />
          <path
            d="M190.61,141.51v4.34h.6c.34,0,.61-1,.61-2.17s-.27-2.17-.61-2.17h-.6Z"
            fill="#ccbe9e"
          />
          <ellipse cx="190.64" cy="143.68" rx="0.61" ry="2.17" fill="#3a7599" />
          <path
            d="M188.18,142.47l.22,2.42h2c.16,0,.29-.54.29-1.21s-.13-1.21-.29-1.21h-2.27Z"
            fill="#295566"
          />
          <path
            d="M190,142.21a2.33,2.33,0,0,1,0,2.94h-1.53a3.56,3.56,0,0,0,0-2.94Z"
            fill="#3a7599"
          />
          <path
            d="M191.32,141.54a3.22,3.22,0,0,1,.5,2.14v.21c-.11-.32-.29-.64-.57-.44,0,0-.07-1.75-.58-1.94h.6Z"
            fill="#f9e9ca"
          />
          <path
            d="M188.73,144.13h0a4.75,4.75,0,0,1-.29,1H190a2.33,2.33,0,0,0,0-2.94h-.51S190.23,144.08,188.73,144.13Z"
            fill="#33667f"
          />
          <path
            d="M179.88,160.53c5.1,0,8.8-11.25,10.08-15.36v0l-1.4,0c-.13.66-3.07,14.84-8.68,14.72s-8.68-14.3-8.68-14.3h-1.53a10.72,10.72,0,0,1,1.79,3.64C172.16,151.53,174.78,160.53,179.88,160.53Z"
            fill="#33667f"
          />
          <g>
            <path
              d="M175,159.45h0l.45.41C175.56,159.86,175.44,159.74,175,159.45Z"
              fill="#f9e9ca"
              opacity="0.25"
            />
            <path
              d="M170,147.83c.52,2.87,1.73,7.77,4.34,10.87-1.75-2.53-2.87-9.11-4.34-10.87Z"
              fill="#f9e9ca"
              opacity="0.25"
            />
          </g>
          <path
            d="M172.3,139c.31-.27.66-.58,1-.92a15.68,15.68,0,0,1,4.23-2.42,10.3,10.3,0,0,0-4.23,1.59A8.06,8.06,0,0,0,172.3,139Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
          <path
            d="M178.65,157.53c-1.88-1.48-5.89-7.56-5.89-7.56h0C174.14,153.22,176.29,156.68,178.65,157.53Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
          <circle cx="183.52" cy="140.49" r="1.15" fill="#20323f" />
          <path
            d="M181.86,140.49a1.66,1.66,0,0,1,3.32,0"
            fill="none"
            stroke="#20323f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.45"
          />
          <path
            d="M179.92,188.87h0a2,2,0,0,1-2-2V161.52c0-1.1.93-1,2-1h0c1.1,0,2-.11,2,1v25.34A2,2,0,0,1,179.92,188.87Z"
            fill="#3a7599"
          />
          <g>
            <path
              d="M178.54,186.86V161.52c0-.83-.63-1.05-.63,0v25.34a2,2,0,0,0,2,2h0l.32,0A2,2,0,0,1,178.54,186.86Z"
              fill="#f9e9ca"
              opacity="0.25"
            />
            <path d="M180.59,160.53Z" fill="#f9e9ca" opacity="0.25" />
          </g>
          <path
            d="M181.23,187V161.65c0-.83.63-1.05.63,0V187a2,2,0,0,1-2,2h0a1.73,1.73,0,0,1-.32,0A2,2,0,0,0,181.23,187Z"
            fill="#33667f"
            opacity="0.61"
          />
        </g>
        <g>
          <path
            d="M142,53.89v4.34h-.6c-.34,0-.61-1-.61-2.17s.27-2.17.61-2.17h.6Z"
            fill="#ccbe9e"
          />
          <ellipse cx="142" cy="56.06" rx="0.61" ry="2.17" fill="#3a7599" />
          <path
            d="M144.46,54.85l-.22,2.43h-2.05c-.16,0-.28-.55-.28-1.22s.12-1.21.28-1.21h2.27Z"
            fill="#295566"
          />
          <path
            d="M142.67,54.6a2.31,2.31,0,0,0,0,2.93h1.53a3.54,3.54,0,0,1,0-2.93Z"
            fill="#3a7599"
          />
          <path
            d="M142.67,57.53s1.47,15.9,10.21,16S163,57.09,163,57.09h-1.4S158.63,72,152.88,71.83s-8.68-14.3-8.68-14.3Z"
            fill="#3a7599"
          />
          <path
            d="M146.31,49.23s4.53-3.44,12.32-.76c0,0,2.81,3.57,2.81,7.21s-4,13.79-8.56,14-8.68-10.4-8.68-13.34A11.82,11.82,0,0,1,146.31,49.23Z"
            fill="#33667f"
          />
          <circle cx="152.82" cy="56.38" r="8.36" fill="#295566" />
          <circle cx="152.82" cy="56.38" r="7.91" fill="#90a5b7" />
          <circle
            cx="149.76"
            cy="52.49"
            r="1.66"
            fill="#33667f"
            opacity="0.51"
          />
          <circle
            cx="156.71"
            cy="52.49"
            r="1.66"
            fill="#33667f"
            opacity="0.51"
          />
          <circle cx="149.57" cy="52.49" r="1.66" fill="#2f506a" />
          <path
            d="M147.91,52.49a1.66,1.66,0,1,1,3.32,0"
            fill="none"
            stroke="#20323f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.45"
          />
          <circle cx="149.57" cy="52.49" r="1.15" fill="#20323f" />
          <circle cx="156.52" cy="52.49" r="1.15" fill="#20323f" />
          <circle cx="156.52" cy="52.49" r="1.66" fill="#275474" />
          <path
            d="M143.18,54.6s.64,1.85-1,1.78a2.89,2.89,0,0,0,.48,1.15h1.53a3.54,3.54,0,0,1,0-2.93Z"
            fill="#33667f"
          />
          <path
            d="M141.33,53.92a3.16,3.16,0,0,0-.51,2.14v.22c.11-.33.3-.65.58-.45,0,0,.06-1.74.57-1.94h-.6Z"
            fill="#f9e9ca"
          />
          <path
            d="M163.61,53.51v4.34h.6c.34,0,.61-1,.61-2.17s-.27-2.17-.61-2.17h-.6Z"
            fill="#ccbe9e"
          />
          <ellipse cx="163.64" cy="55.68" rx="0.61" ry="2.17" fill="#3a7599" />
          <path
            d="M161.18,54.47l.22,2.42h2c.16,0,.29-.54.29-1.21s-.13-1.21-.29-1.21h-2.27Z"
            fill="#295566"
          />
          <path
            d="M163,54.21a2.33,2.33,0,0,1,0,2.94h-1.53a3.56,3.56,0,0,0,0-2.94Z"
            fill="#3a7599"
          />
          <path
            d="M164.32,53.54a3.22,3.22,0,0,1,.5,2.14v.21c-.11-.32-.29-.64-.57-.44,0,0-.07-1.75-.58-1.94h.6Z"
            fill="#f9e9ca"
          />
          <path
            d="M161.73,56.13h0a4.75,4.75,0,0,1-.29,1H163a2.33,2.33,0,0,0,0-2.94h-.51S163.23,56.08,161.73,56.13Z"
            fill="#33667f"
          />
          <path
            d="M152.88,72.53c5.1,0,8.8-11.25,10.08-15.36v0l-1.4,0c-.13.66-3.07,14.84-8.68,14.72s-8.68-14.3-8.68-14.3h-1.53a10.72,10.72,0,0,1,1.79,3.64C145.16,63.53,147.78,72.53,152.88,72.53Z"
            fill="#33667f"
          />
          <g>
            <path
              d="M148,71.45h0l.45.41C148.56,71.86,148.44,71.74,148,71.45Z"
              fill="#f9e9ca"
              opacity="0.25"
            />
            <path
              d="M143,59.83c.52,2.87,1.73,7.77,4.34,10.87-1.75-2.53-2.87-9.11-4.34-10.87Z"
              fill="#f9e9ca"
              opacity="0.25"
            />
          </g>
          <path
            d="M145.3,51c.31-.27.66-.58,1-.92a15.68,15.68,0,0,1,4.23-2.42,10.3,10.3,0,0,0-4.23,1.59A8.06,8.06,0,0,0,145.3,51Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
          <path
            d="M151.65,69.53c-1.88-1.48-5.89-7.56-5.89-7.56h0C147.14,65.22,149.29,68.68,151.65,69.53Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
          <circle cx="156.52" cy="52.49" r="1.15" fill="#20323f" />
          <path
            d="M154.86,52.49a1.66,1.66,0,0,1,3.32,0"
            fill="none"
            stroke="#20323f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.45"
          />
          <path
            d="M152.92,100.87h0a2,2,0,0,1-2-2V73.52c0-1.1.93-1,2-1h0c1.1,0,2-.11,2,1V98.86A2,2,0,0,1,152.92,100.87Z"
            fill="#3a7599"
          />
          <g>
            <path
              d="M151.54,98.86V73.52c0-.83-.63-1-.63,0V98.86a2,2,0,0,0,2,2h0l.32,0A2,2,0,0,1,151.54,98.86Z"
              fill="#f9e9ca"
              opacity="0.25"
            />
            <path d="M153.59,72.53Z" fill="#f9e9ca" opacity="0.25" />
          </g>
          <path
            d="M154.23,99V73.65c0-.83.63-1.05.63,0V99a2,2,0,0,1-2,2h0a1.73,1.73,0,0,1-.32,0A2,2,0,0,0,154.23,99Z"
            fill="#33667f"
            opacity="0.61"
          />
        </g>
        <circle
          cx="252.32"
          cy="321.5"
          r="69"
          strokeMiterlimit="10"
          opacity="0.65"
          fill="url(#b820efa6-46e9-47b4-99e3-b3251c2375d7)"
          stroke="url(#a06df8d4-299d-4a42-ad89-eeeacef31b78)"
        />
        <g>
          <path
            d="M434.32,139.9c0,32.26-77.9,58.41-174,58.41s-174-26.15-174-58.41a23.15,23.15,0,0,1,4.58-13.36c18,23.94,87,41.77,169.42,41.77s151.42-17.83,169.42-41.77A23.15,23.15,0,0,1,434.32,139.9Z"
            fill="#88bfe2"
            opacity="0.26"
          />
          <g>
            <line
              x1="113.82"
              y1="143.5"
              x2="113.82"
              y2="171.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="152.82"
              y1="156.5"
              x2="152.82"
              y2="184.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="91.82"
              y1="127.5"
              x2="91.82"
              y2="155.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="85.82"
              y1="117.5"
              x2="85.82"
              y2="139.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="96.82"
              y1="95.5"
              x2="96.82"
              y2="119.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="115.82"
              y1="83.5"
              x2="115.82"
              y2="107.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="140.82"
              y1="74.5"
              x2="140.82"
              y2="97.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="167.82"
              y1="68.5"
              x2="167.82"
              y2="91.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="199.82"
              y1="63.5"
              x2="199.82"
              y2="85.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="231.82"
              y1="60.5"
              x2="231.82"
              y2="81.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="271.82"
              y1="60.5"
              x2="271.82"
              y2="81.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="311.82"
              y1="62.5"
              x2="311.82"
              y2="85.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="344.82"
              y1="66.5"
              x2="344.82"
              y2="88.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="376.82"
              y1="73.5"
              x2="376.82"
              y2="97.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="403.82"
              y1="84.5"
              x2="403.82"
              y2="108.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="422.82"
              y1="94.5"
              x2="422.82"
              y2="117.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="193.32"
              y1="165"
              x2="193.32"
              y2="191.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="235.82"
              y1="167"
              x2="235.82"
              y2="198.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="275.82"
              y1="169"
              x2="275.82"
              y2="198.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="312.82"
              y1="165.5"
              x2="312.82"
              y2="193.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="375.82"
              y1="154.5"
              x2="375.82"
              y2="182.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="344.82"
              y1="162"
              x2="344.82"
              y2="191.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="407.32"
              y1="143"
              x2="407.32"
              y2="171.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="426.82"
              y1="130"
              x2="426.82"
              y2="159.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
            <line
              x1="434.82"
              y1="117.5"
              x2="434.82"
              y2="140.64"
              fill="#046582"
              stroke="#6ef4ed"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.66"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M377.4,59.4l1.78.26,1.8.23c-.15-.92-.32-1.83-.51-2.75s-.41-1.78-.66-2.62c-.45.85-.87,1.68-1.27,2.49S377.77,58.61,377.4,59.4Zm-5.47,2.53c-.57-.17-.82-.48-.75-1s.1-.72.16-1a6.87,6.87,0,0,1,.19-.83.72.72,0,0,1,.36-.47.91.91,0,0,1,.52-.07c.19,0,.51.1,1,.21.66-1.35,1.36-2.68,2.08-4s1.43-2.54,2.12-3.69a1.37,1.37,0,0,1,1.09-.71c.39,0,.79,0,1.2,0s.78,0,1.11.1l.55.09.42.09a1.31,1.31,0,0,1,.94.89q.48,1.42,1.11,3.72t1.19,5.06l.54,0,.3,0h.19a.75.75,0,0,1,.69.74,4.85,4.85,0,0,1,0,1.3l-.05.35a1.78,1.78,0,0,1-.1.38,1,1,0,0,1-.34.57,1,1,0,0,1-.6.13c.05.35.1.68.14,1s.06.58.09.82a1.81,1.81,0,0,1,0,.37.81.81,0,0,1,0,.16.67.67,0,0,1-.62.62A10.41,10.41,0,0,1,384,67a8.4,8.4,0,0,1-1.41-.08.85.85,0,0,1-.56-.27,1.22,1.22,0,0,1-.22-.62l-.29-2.34c-.83-.07-1.66-.17-2.5-.29l-1.59-.25-1.54-.29c-.16.4-.31.8-.46,1.18s-.28.76-.4,1.13a.79.79,0,0,1-.95.61,7.36,7.36,0,0,1-1.32-.32,11.73,11.73,0,0,1-1.27-.49.72.72,0,0,1-.44-.8s0-.09,0-.15a1.65,1.65,0,0,1,.1-.29q.1-.35.3-.81C371.64,62.59,371.77,62.26,371.93,61.93Z"
                fill="#e4982f"
              />
              <path
                d="M389.07,56.05c.09-.42.23-.67.43-.75a3,3,0,0,1,.81-.16,29.42,29.42,0,0,1,6.13.33,15,15,0,0,1,2.23.49,9.29,9.29,0,0,1,1.91.79,4.19,4.19,0,0,1,1.29,1.11,1.86,1.86,0,0,1,.35,1.41,3.09,3.09,0,0,1-.43,1.19,3.73,3.73,0,0,1-.86,1,6.76,6.76,0,0,1-1.19.77,13.53,13.53,0,0,1-1.44.6,7.64,7.64,0,0,1,1.61.57,4.64,4.64,0,0,1,1.25.87,3,3,0,0,1,.86,2.68,4,4,0,0,1-.84,2,5.65,5.65,0,0,1-1.77,1.45,7.71,7.71,0,0,1-2.47.79,9.61,9.61,0,0,1-3,0c-.53-.07-1.12-.18-1.77-.32a12.74,12.74,0,0,1-1.76-.49,1.86,1.86,0,0,1-.88-.63,2.4,2.4,0,0,1-.26-1.46c0-.75.07-1.46.11-2.12s.08-1.32.14-1.94.13-1.24.2-1.85.16-1.23.25-1.85l.2-1.39a2.28,2.28,0,0,1-.64,0,.75.75,0,0,1-.66-.8,4.07,4.07,0,0,1,0-.78,6.87,6.87,0,0,1,.08-.78l0-.33C389,56.27,389,56.16,389.07,56.05Zm5.1,2.84c-.06.47-.13.94-.19,1.39s-.11.92-.16,1.39a9,9,0,0,0,2.71-.8,4.29,4.29,0,0,0,1.6-1.19,5.37,5.37,0,0,0-2.07-.64c-.29,0-.6-.07-.91-.09Zm3.69,7.28a.68.68,0,0,0-.14-.54,1.69,1.69,0,0,0-.54-.42,3.34,3.34,0,0,0-.83-.31,7.69,7.69,0,0,0-1-.2,11.63,11.63,0,0,0-1.82-.13l-.22,2.62a7.61,7.61,0,0,0,.75.2l.69.12a4.22,4.22,0,0,0,2.16-.14A1.46,1.46,0,0,0,397.86,66.17Z"
                fill="#f3de3d"
              />
              <path
                d="M403.12,63.25a9.36,9.36,0,0,1,.26-3.63,8.76,8.76,0,0,1,1.54-3.1,9.15,9.15,0,0,1,2.58-2.25,8.52,8.52,0,0,1,3.39-1.1,10.87,10.87,0,0,1,1.71-.07l.09-.4a.71.71,0,0,1,.65-.65,4,4,0,0,1,1,.06,6.54,6.54,0,0,1,1.25.29.78.78,0,0,1,.54.71,1.79,1.79,0,0,1,0,.33c0,.46-.09,1-.16,1.49s-.16,1.07-.25,1.61-.18,1.09-.28,1.61-.19,1-.28,1.45a1.08,1.08,0,0,1-.24.56.69.69,0,0,1-.49.22l-.15,0a1.56,1.56,0,0,1-.29,0c-.2,0-.44,0-.7,0a5.9,5.9,0,0,1-.8-.15.87.87,0,0,1-.56-.36,1.07,1.07,0,0,1-.19-.46.61.61,0,0,1,0-.14s0-.18,0-.39.05-.54.09-1,.1-.83.16-1.28h-.31l-.35,0a4.22,4.22,0,0,0-1.58.53,5.14,5.14,0,0,0-1.36,1.15,5,5,0,0,0-.91,1.64,4.47,4.47,0,0,0-.18,2,4.11,4.11,0,0,0,.4,1.41,3.47,3.47,0,0,0,.83,1.09,3.26,3.26,0,0,0,1.21.64,3.7,3.7,0,0,0,1.54.11,7.35,7.35,0,0,0,2-.52,13.14,13.14,0,0,0,1.87-1,1.28,1.28,0,0,1,.5-.21.7.7,0,0,1,.56.29,3.78,3.78,0,0,1,1,2.05,1.45,1.45,0,0,1,0,.55.87.87,0,0,1-.29.47,6.9,6.9,0,0,1-1.15.87,14.23,14.23,0,0,1-1.46.74,13.31,13.31,0,0,1-1.57.55,9,9,0,0,1-1.48.3,8.33,8.33,0,0,1-2.87-.14,7,7,0,0,1-2.49-1.1,6.35,6.35,0,0,1-1.85-2A7,7,0,0,1,403.12,63.25Z"
                fill="#e8abcd"
              />
            </g>
            <ellipse
              cx="394.5"
              cy="61.1"
              rx="40.18"
              ry="20.76"
              fill="none"
              stroke="#db3669"
              strokeMiterlimit="10"
              strokeWidth="6.7"
            />
            <image
              width="160"
              height="122"
              transform="translate(314.82)"
              xlinkHref="data:image/png;base64,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"
            />
            <ellipse
              cx="394.5"
              cy="59.76"
              rx="40.18"
              ry="20.76"
              fill="none"
              stroke="#e1e1ef"
              strokeMiterlimit="10"
              strokeWidth="1.34"
            />
          </g>
          <g>
            <ellipse
              cx="393.96"
              cy="130.54"
              rx="22.95"
              ry="4.67"
              fill="#7f4896"
            />
            <path
              d="M422.3,112.15v6.47c0,.59-.61,1.15-1.72,1.67-4,1.88-14.39,3.21-26.62,3.21s-22.66-1.33-26.62-3.21c-1.11-.52-1.72-1.08-1.72-1.67v-6.47c0,1.24,2.68,2.37,7.1,3.24A118.78,118.78,0,0,0,394,117a118.78,118.78,0,0,0,21.24-1.65C419.62,114.52,422.3,113.39,422.3,112.15Z"
              fill="#9fb8ad"
            />
            <path
              d="M422.15,110.72v6.46c0,.59-.6,1.15-1.71,1.68-4,1.87-14.39,3.21-26.62,3.21s-22.66-1.34-26.63-3.21c-1.11-.53-1.71-1.09-1.71-1.68v-6.46c0,1.24,2.68,2.37,7.09,3.23a119,119,0,0,0,21.25,1.65A118.87,118.87,0,0,0,415.06,114C419.47,113.09,422.15,112,422.15,110.72Z"
              fill="#9fb8ad"
            />
            <path
              d="M422.15,112.64v4.54c0,.59-.6,1.15-1.71,1.68-4,1.87-14.39,3.21-26.62,3.21s-22.66-1.34-26.63-3.21a3.61,3.61,0,0,1-1.57-1.19v1c0,.59.61,1.15,1.72,1.67,4,1.88,14.39,3.21,26.62,3.21s22.66-1.33,26.62-3.21c1.11-.52,1.72-1.08,1.72-1.67v-6.47A.91.91,0,0,1,422.15,112.64Z"
              fill="#434c68"
              opacity="0.56"
              style={{ mixBlendMode: 'multiply' }}
            />
            <path
              d="M422.15,110.86c0,1.24-2.68,2.37-7.09,3.23a117.94,117.94,0,0,1-21.24,1.65,118.06,118.06,0,0,1-21.25-1.65c-4.41-.86-7.09-2-7.09-3.23,0-2.7,12.69-4.88,28.34-4.88S422.15,108.16,422.15,110.86Z"
              fill="#c5d7bd"
            />
            <image
              width="81"
              height="78"
              transform="translate(374.82 80)"
              xlinkHref="data:image/png;base64,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"
            />
            <path
              d="M416.88,112.58c0,1-2.17,1.92-5.74,2.62a111.62,111.62,0,0,1-34.36,0c-3.57-.7-5.74-1.61-5.74-2.62,0-2.18,10.26-4,22.92-4S416.88,110.4,416.88,112.58Z"
              fill="#434c68"
              style={{ mixBlendMode: 'multiply' }}
            />
            <path
              d="M408.55,113.88c0,.63-1.38,1.22-3.66,1.66a70.7,70.7,0,0,1-21.86,0c-2.28-.44-3.66-1-3.66-1.66,0-1.39,6.53-2.52,14.59-2.52S408.55,112.49,408.55,113.88Z"
              fill="#9fb8ad"
              stroke="#efe922"
              strokeMiterlimit="10"
              strokeWidth="0.07"
            />
            <path
              d="M406,113.88c0,.52-1.14,1-3,1.37a58.46,58.46,0,0,1-18,0c-1.87-.37-3-.85-3-1.37,0-1.15,5.38-2.08,12-2.08S406,112.73,406,113.88Z"
              fill="#383e56"
              stroke="#efe922"
              strokeMiterlimit="10"
              strokeWidth="0.29"
            />
            <path
              d="M404,113.88c0,.43-.94.83-2.5,1.14a48.78,48.78,0,0,1-15,0c-1.56-.31-2.5-.71-2.5-1.14,0-1,4.48-1.73,10-1.73S404,112.92,404,113.88Z"
              fill="#9fb8ad"
              stroke="#efe922"
              strokeMiterlimit="10"
              strokeWidth="0.07"
            />
            <path
              d="M401.83,113.88c0,.34-.75.66-2,.89a38.07,38.07,0,0,1-11.8,0c-1.22-.23-2-.55-2-.89,0-.75,3.53-1.36,7.87-1.36S401.83,113.13,401.83,113.88Z"
              fill="#383e56"
              stroke="#efe922"
              strokeMiterlimit="10"
              strokeWidth="0.29"
            />
            <path
              d="M411.74,118v3s5.17-.57,7.18-1.65v-2.88A30.67,30.67,0,0,1,411.74,118Z"
              fill="url(#f23fca45-a36c-49c7-8a89-03ec36ef30f1)"
            />
            <image
              width="78"
              height="76"
              transform="translate(367.82 82)"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABMCAYAAADDYoEWAAAACXBIWXMAAAsSAAALEgHS3X78AAAD+UlEQVR4Xu2au27jMBBFL7MCNkacIkV6F+5S5gf1gynTLFy4d5EiDjYLOOEW1EgkNTQlmqSFYA5g2HqCczCkyJGV1hrCfG5iJwg8Ii4REZeIiEtExCUi4hIRcYmIuEREXCIiLhERl4iIS0TEJSLiEhFxiSxXnFIKSqnYaddCLaKQOVfQAhp9PXFzZYW4UgD1xeUS5lM5kHripgmLnRNvbKWAyouLC7OOt8GTmOPnG144sLLizkvrjrXe7tfANU9eQ1v6EQ6gYHDlxIWlMcJCskLYElv6wQdSKMCa4pguyQk7BCQ+Mg0lga290z2vUIBlxAWltd2mLywkK4QvcSSwuLz84vguqkxQMWHv3fazuxsv3fe911hOYAtw3TZzoE3shAxEuiMn68275pmCVq5Eus+oGyvEnroXkjfjJmUbBWsL80UBeOq+X0dHADzocRaSvDpZV1qcGo9rBxWWdlTYgmcHAGursb48WxzAyssYbKXqiJ9tgCvtqLC1pJ3+KucDAFsA26MCjt01b8rt3nTvuVObNPJl3Kxss6RtOxEkCBvw7M1XszIN3lH2UebVzboKDwcu26xMAzppG7Pr9MFnTLMxAZ/2ysg7KtN13xR6OQdl5L2q8UojL6W6aqC7ULYB/XhG0k4fypH2/anw/Tls98c35pptdw8A5p7vw7kuRbpuHnHs07QFn20RfGH+dhR7rGvHh+NFh0nkETcLGtvgZhuAs4Lo2CjrAHY6U5jK4vwVQYCvf8r5TGLivTNRUZw1BtGTdGq2EX7WAda9gDPjXHYqivtZVBRnLdD7OdgeaO7M75vb+PSBzmnudD+v29mrCb8IUI6K4oBhiRTh12/tfCYx8d6ZqCwOMDN9mLVns9KTs87PtmalzfoV6O9ZkTzi2GVMi2H2zlVvA9zcakegvx1lVCVxybTkyiNuTKBx93roUms9yjrKPGAsrD++t7KNxjdaq7JkEeVTYa36pM0s/lEPs/oHbSataw0czdrztDfHaE06Ym++aJEPe5FP+Iv8cuSrjgBnKiRcEdMvK1lX9ZWSjl4WvLqcXRkBosXMjMGW6qoe3Fj3giFb1hq79TDYNyvtfAAjbLfWY2lEvWwDymccIKXziZx9NchVS6a8rLHHMe6NF/skLdZNgSoPB2iMamIU6EENAv7AkugFacu6t/YHpzlZJXHkzzhAXkhfhPwFIhH5080FyN+8LiBe42e6cAjn+PmGFw6svDgiLhCIv5GKN7ZSQPXEEdMEzqdyIPXFEbkEXimA64mzmStxAY1ehjgOkrnQBi5X3MKpVFb6eYi4RERcIiIuERGXiIhLRMQlIuISEXGJiLhERFwiIi4REZeIiEtExCXyH+VvEWPSp0F0AAAAAElFTkSuQmCC"
            />
            <path
              d="M371,112.58a80.58,80.58,0,0,1,8.33,1.3A80.58,80.58,0,0,1,371,112.58Z"
              fill="#1ef9aa"
            />
            <path
              d="M375.18,110.32a35.82,35.82,0,0,1,4.68,2.91A35.17,35.17,0,0,1,375.18,110.32Z"
              fill="#1ef9aa"
            />
            <path
              d="M379.86,109.47a17.28,17.28,0,0,1,2.7,2.84A18.13,18.13,0,0,1,379.86,109.47Z"
              fill="#1ef9aa"
            />
            <path
              d="M384,109a10.21,10.21,0,0,1,1,2.77A10.1,10.1,0,0,1,384,109Z"
              fill="#1ef9aa"
            />
            <path
              d="M387.29,108.8a9.2,9.2,0,0,1,.48,2.8A9.51,9.51,0,0,1,387.29,108.8Z"
              fill="#1ef9aa"
            />
            <path
              d="M390.16,108.69a8.52,8.52,0,0,1,0,2.76A9.12,9.12,0,0,1,390.16,108.69Z"
              fill="#1ef9aa"
            />
            <path
              d="M392.65,108.69a8,8,0,0,1,0,2.68A8.6,8.6,0,0,1,392.65,108.69Z"
              fill="#1ef9aa"
            />
            <path
              d="M395.53,108.69a8.35,8.35,0,0,1-.27,2.68A8.64,8.64,0,0,1,395.53,108.69Z"
              fill="#1ef9aa"
            />
            <path
              d="M397.76,108.69a9.15,9.15,0,0,1-.6,2.73A9.15,9.15,0,0,1,397.76,108.69Z"
              fill="#1ef9aa"
            />
            <path
              d="M400.64,108.8a9.5,9.5,0,0,1-1,2.63A9.32,9.32,0,0,1,400.64,108.8Z"
              fill="#1ef9aa"
            />
            <path
              d="M403,109a10.44,10.44,0,0,1-1.56,2.63A11.07,11.07,0,0,1,403,109Z"
              fill="#1ef9aa"
            />
            <path
              d="M405.88,109.21a12.74,12.74,0,0,1-2,2.58A12.4,12.4,0,0,1,405.88,109.21Z"
              fill="#1ef9aa"
            />
            <path
              d="M408.55,109.54a21.07,21.07,0,0,1-3.19,2.77A20,20,0,0,1,408.55,109.54Z"
              fill="#1ef9aa"
            />
            <path
              d="M411.45,110a29.56,29.56,0,0,1-4.2,2.81A29.56,29.56,0,0,1,411.45,110Z"
              fill="#1ef9aa"
            />
            <path
              d="M414.67,110.89a55.38,55.38,0,0,1-6.09,3A51.26,51.26,0,0,1,414.67,110.89Z"
              fill="#1ef9aa"
            />
            <path
              d="M415.62,113.88a73,73,0,0,1-7.81.79A70.51,70.51,0,0,1,415.62,113.88Z"
              fill="#1ef9aa"
            />
            <path
              d="M407.81,115.73a2.47,2.47,0,0,1-1.34-.56A2.47,2.47,0,0,1,407.81,115.73Z"
              fill="#1ef9aa"
            />
            <path
              d="M374.49,114.67a32.1,32.1,0,0,1,5.37,0A34.38,34.38,0,0,1,374.49,114.67Z"
              fill="#1ef9aa"
            />
            <path
              d="M380.52,115.78a2.62,2.62,0,0,1,1.4-.48A2.51,2.51,0,0,1,380.52,115.78Z"
              fill="#1ef9aa"
            />
            <path
              d="M420.62,120.44l-1.81,1.75-6.51,6.3c0,1.75-8.24,3.12-18.37,3.06s-18.35-1.52-18.34-3.27l-6-6-2.2-2.18c3.95,1.89,14.37,3.28,26.6,3.35S416.64,122.29,420.62,120.44Z"
              fill="#434c68"
            />
            <path
              d="M404.48,118.83v3a27,27,0,0,0,5-.36v-3A30,30,0,0,1,404.48,118.83Z"
              fill="url(#e2a1374e-ec02-43e7-a8b1-5ef6676e838e)"
            />
            <path
              d="M412.3,128.49l.31-.3c-17.91,2.19-30.13,1.12-37.31-.19l.29.28c0,1.75,8.2,3.21,18.34,3.27S412.29,130.24,412.3,128.49Z"
              fill="#434c68"
              style={{ mixBlendMode: 'multiply' }}
            />
            <ellipse
              cx="393.76"
              cy="111.55"
              rx="26.89"
              ry="5.45"
              opacity="0.76"
              fill="url(#b18dac75-3b4f-43e5-86a2-f60df46c4fea)"
              style={{ mixBlendMode: 'color-dodge' }}
            />
          </g>
          <path
            d="M421.75,82.13c0,6.11-.28,30.3-27.7,30.3S365.51,85,365.51,78.86s1.53,3.27,28.94,3.27S421.75,76,421.75,82.13Z"
            opacity="0.76"
            fill="url(#b9c0f194-cd34-4afc-bbe3-9b597dc8850e)"
            style={{ mixBlendMode: 'color-dodge' }}
          />
        </g>
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(120, 70)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
      <g>
        <path
          d="M359,137.89v4.34h-.6c-.34,0-.61-1-.61-2.17s.27-2.17.61-2.17h.6Z"
          fill="#ccbe9e"
        />
        <ellipse cx="359" cy="140.06" rx="0.61" ry="2.17" fill="#3a7599" />
        <path
          d="M361.46,138.85l-.22,2.43h-2.05c-.16,0-.28-.55-.28-1.22s.12-1.21.28-1.21h2.27Z"
          fill="#295566"
        />
        <path
          d="M359.67,138.6a2.31,2.31,0,0,0,0,2.93h1.53a3.54,3.54,0,0,1,0-2.93Z"
          fill="#3a7599"
        />
        <path
          d="M359.67,141.53s1.47,15.9,10.21,16S380,141.09,380,141.09h-1.4s-2.94,14.87-8.69,14.74-8.68-14.3-8.68-14.3Z"
          fill="#3a7599"
        />
        <path
          d="M363.31,133.23s4.53-3.44,12.32-.76c0,0,2.81,3.57,2.81,7.21s-4,13.79-8.56,14-8.68-10.4-8.68-13.34A11.82,11.82,0,0,1,363.31,133.23Z"
          fill="#33667f"
        />
        <circle cx="369.82" cy="140.38" r="8.36" fill="#295566" />
        <circle cx="369.82" cy="140.38" r="7.91" fill="#90a5b7" />
        <circle
          cx="366.76"
          cy="136.49"
          r="1.66"
          fill="#33667f"
          opacity="0.51"
        />
        <circle
          cx="373.71"
          cy="136.49"
          r="1.66"
          fill="#33667f"
          opacity="0.51"
        />
        <circle cx="366.57" cy="136.49" r="1.66" fill="#2f506a" />
        <path
          d="M364.91,136.49a1.66,1.66,0,0,1,3.32,0"
          fill="none"
          stroke="#20323f"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="0.45"
        />
        <circle cx="366.57" cy="136.49" r="1.15" fill="#20323f" />
        <path
          d="M369.76,143.83a.48.48,0,0,1-.46-.39c-.17-1.07-.5-3.95.9-3.95s1.25,2.83,1.14,3.92a.47.47,0,0,1-.46.42Z"
          fill="#33667f"
          opacity="0.51"
        />
        <circle cx="373.52" cy="136.49" r="1.15" fill="#20323f" />
        <circle cx="373.52" cy="136.49" r="1.66" fill="#275474" />
        <path
          d="M369.38,143.83a.47.47,0,0,1-.46-.39c-.17-1.07-.5-3.95.9-3.95s1.24,2.83,1.14,3.92a.48.48,0,0,1-.47.42Z"
          fill="#2f506a"
        />
        <circle cx="369.82" cy="140.38" r="0.89" fill="#38607a" />
        <circle cx="369.82" cy="140.38" r="0.7" fill="#20323f" />
        <path
          d="M360.18,138.6s.64,1.85-1,1.78a2.89,2.89,0,0,0,.48,1.15h1.53a3.54,3.54,0,0,1,0-2.93Z"
          fill="#33667f"
        />
        <path
          d="M358.33,137.92a3.16,3.16,0,0,0-.51,2.14v.22c.11-.33.3-.65.58-.45,0,0,.06-1.74.57-1.94h-.6Z"
          fill="#f9e9ca"
        />
        <path
          d="M380.61,137.51v4.34h.6c.34,0,.61-1,.61-2.17s-.27-2.17-.61-2.17h-.6Z"
          fill="#ccbe9e"
        />
        <ellipse cx="380.64" cy="139.68" rx="0.61" ry="2.17" fill="#3a7599" />
        <path
          d="M378.18,138.47l.22,2.42h2.05c.16,0,.29-.54.29-1.21s-.13-1.21-.29-1.21h-2.27Z"
          fill="#295566"
        />
        <path
          d="M380,138.21a2.33,2.33,0,0,1,0,2.94h-1.53a3.56,3.56,0,0,0,0-2.94Z"
          fill="#3a7599"
        />
        <path
          d="M381.32,137.54a3.22,3.22,0,0,1,.5,2.14v.21c-.11-.32-.29-.64-.57-.44,0,0-.07-1.75-.58-1.94h.6Z"
          fill="#f9e9ca"
        />
        <path
          d="M378.73,140.13h0a4.75,4.75,0,0,1-.29,1H380a2.33,2.33,0,0,0,0-2.94h-.51S380.23,140.08,378.73,140.13Z"
          fill="#33667f"
        />
        <path
          d="M369.88,156.53c5.1,0,8.8-11.25,10.08-15.36v0l-1.4,0c-.13.66-3.07,14.84-8.68,14.72s-8.68-14.3-8.68-14.3h-1.53a10.72,10.72,0,0,1,1.79,3.64C362.16,147.53,364.78,156.53,369.88,156.53Z"
          fill="#33667f"
        />
        <g>
          <path
            d="M365,155.45h0l.45.41C365.56,155.86,365.44,155.74,365,155.45Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
          <path
            d="M360,143.83c.52,2.87,1.73,7.77,4.34,10.87-1.75-2.53-2.87-9.11-4.34-10.87Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
        </g>
        <path
          d="M362.3,135c.31-.27.66-.58,1-.92a15.68,15.68,0,0,1,4.23-2.42,10.3,10.3,0,0,0-4.23,1.59A8.06,8.06,0,0,0,362.3,135Z"
          fill="#f9e9ca"
          opacity="0.25"
        />
        <path
          d="M368.65,153.53c-1.88-1.48-5.89-7.56-5.89-7.56h0C364.14,149.22,366.29,152.68,368.65,153.53Z"
          fill="#f9e9ca"
          opacity="0.25"
        />
        <circle cx="373.52" cy="136.49" r="1.15" fill="#20323f" />
        <path
          d="M371.86,136.49a1.66,1.66,0,0,1,3.32,0"
          fill="none"
          stroke="#20323f"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="0.45"
        />
        <path
          d="M369.92,184.87h0a2,2,0,0,1-2-2V157.52c0-1.1.93-1,2-1h0c1.1,0,2-.11,2,1v25.34A2,2,0,0,1,369.92,184.87Z"
          fill="#3a7599"
        />
        <g>
          <path
            d="M368.54,182.86V157.52c0-.83-.63-1.05-.63,0v25.34a2,2,0,0,0,2,2h0l.32,0A2,2,0,0,1,368.54,182.86Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
          <path d="M370.59,156.53Z" fill="#f9e9ca" opacity="0.25" />
        </g>
        <path
          d="M371.23,183V157.65c0-.83.63-1.05.63,0V183a2,2,0,0,1-2,2h0a1.73,1.73,0,0,1-.32,0A2,2,0,0,0,371.23,183Z"
          fill="#33667f"
          opacity="0.61"
        />
      </g>
      <g>
        <path
          d="M251,147.89v4.34h-.6c-.34,0-.61-1-.61-2.17s.27-2.17.61-2.17h.6Z"
          fill="#ccbe9e"
        />
        <ellipse cx="251" cy="150.06" rx="0.61" ry="2.17" fill="#3a7599" />
        <path
          d="M253.46,148.85l-.22,2.43h-2.05c-.16,0-.28-.55-.28-1.22s.12-1.21.28-1.21h2.27Z"
          fill="#295566"
        />
        <path
          d="M251.67,148.6a2.31,2.31,0,0,0,0,2.93h1.53a3.54,3.54,0,0,1,0-2.93Z"
          fill="#3a7599"
        />
        <path
          d="M251.67,151.53s1.47,15.9,10.21,16S272,151.09,272,151.09h-1.4s-2.94,14.87-8.69,14.74-8.68-14.3-8.68-14.3Z"
          fill="#3a7599"
        />
        <path
          d="M255.31,143.23s4.53-3.44,12.32-.76c0,0,2.81,3.57,2.81,7.21s-4,13.79-8.56,14-8.68-10.4-8.68-13.34A11.82,11.82,0,0,1,255.31,143.23Z"
          fill="#33667f"
        />
        <circle cx="261.82" cy="150.38" r="8.36" fill="#295566" />
        <circle cx="261.82" cy="150.38" r="7.91" fill="#90a5b7" />
        <circle
          cx="258.76"
          cy="146.49"
          r="1.66"
          fill="#33667f"
          opacity="0.51"
        />
        <circle
          cx="265.71"
          cy="146.49"
          r="1.66"
          fill="#33667f"
          opacity="0.51"
        />
        <circle cx="258.57" cy="146.49" r="1.66" fill="#2f506a" />
        <path
          d="M256.91,146.49a1.66,1.66,0,0,1,3.32,0"
          fill="none"
          stroke="#20323f"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="0.45"
        />
        <circle cx="258.57" cy="146.49" r="1.15" fill="#20323f" />
        <path
          d="M261.76,153.83a.48.48,0,0,1-.46-.39c-.17-1.07-.5-3.95.9-3.95s1.25,2.83,1.14,3.92a.47.47,0,0,1-.46.42Z"
          fill="#33667f"
          opacity="0.51"
        />
        <circle cx="265.52" cy="146.49" r="1.15" fill="#20323f" />
        <circle cx="265.52" cy="146.49" r="1.66" fill="#275474" />
        <path
          d="M261.38,153.83a.47.47,0,0,1-.46-.39c-.17-1.07-.5-3.95.9-3.95s1.24,2.83,1.14,3.92a.48.48,0,0,1-.47.42Z"
          fill="#2f506a"
        />
        <circle cx="261.82" cy="150.38" r="0.89" fill="#38607a" />
        <circle cx="261.82" cy="150.38" r="0.7" fill="#20323f" />
        <path
          d="M252.18,148.6s.64,1.85-1,1.78a2.89,2.89,0,0,0,.48,1.15h1.53a3.54,3.54,0,0,1,0-2.93Z"
          fill="#33667f"
        />
        <path
          d="M250.33,147.92a3.16,3.16,0,0,0-.51,2.14v.22c.11-.33.3-.65.58-.45,0,0,.06-1.74.57-1.94h-.6Z"
          fill="#f9e9ca"
        />
        <path
          d="M272.61,147.51v4.34h.6c.34,0,.61-1,.61-2.17s-.27-2.17-.61-2.17h-.6Z"
          fill="#ccbe9e"
        />
        <ellipse cx="272.64" cy="149.68" rx="0.61" ry="2.17" fill="#3a7599" />
        <path
          d="M270.18,148.47l.22,2.42h2.05c.16,0,.29-.54.29-1.21s-.13-1.21-.29-1.21h-2.27Z"
          fill="#295566"
        />
        <path
          d="M272,148.21a2.33,2.33,0,0,1,0,2.94h-1.53a3.56,3.56,0,0,0,0-2.94Z"
          fill="#3a7599"
        />
        <path
          d="M273.32,147.54a3.22,3.22,0,0,1,.5,2.14v.21c-.11-.32-.29-.64-.57-.44,0,0-.07-1.75-.58-1.94h.6Z"
          fill="#f9e9ca"
        />
        <path
          d="M270.73,150.13h0a4.75,4.75,0,0,1-.29,1H272a2.33,2.33,0,0,0,0-2.94h-.51S272.23,150.08,270.73,150.13Z"
          fill="#33667f"
        />
        <path
          d="M261.88,166.53c5.1,0,8.8-11.25,10.08-15.36v0l-1.4,0c-.13.66-3.07,14.84-8.68,14.72s-8.68-14.3-8.68-14.3h-1.53a10.72,10.72,0,0,1,1.79,3.64C254.16,157.53,256.78,166.53,261.88,166.53Z"
          fill="#33667f"
        />
        <g>
          <path
            d="M257,165.45h0l.45.41C257.56,165.86,257.44,165.74,257,165.45Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
          <path
            d="M252,153.83c.52,2.87,1.73,7.77,4.34,10.87-1.75-2.53-2.87-9.11-4.34-10.87Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
        </g>
        <path
          d="M254.3,145c.31-.27.66-.58,1-.92a15.68,15.68,0,0,1,4.23-2.42,10.3,10.3,0,0,0-4.23,1.59A8.06,8.06,0,0,0,254.3,145Z"
          fill="#f9e9ca"
          opacity="0.25"
        />
        <path
          d="M260.65,163.53c-1.88-1.48-5.89-7.56-5.89-7.56h0C256.14,159.22,258.29,162.68,260.65,163.53Z"
          fill="#f9e9ca"
          opacity="0.25"
        />
        <circle cx="265.52" cy="146.49" r="1.15" fill="#20323f" />
        <path
          d="M263.86,146.49a1.66,1.66,0,0,1,3.32,0"
          fill="none"
          stroke="#20323f"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="0.45"
        />
        <path
          d="M261.92,194.87h0a2,2,0,0,1-2-2V167.52c0-1.1.93-1,2-1h0c1.1,0,2-.11,2,1v25.34A2,2,0,0,1,261.92,194.87Z"
          fill="#3a7599"
        />
        <g>
          <path
            d="M260.54,192.86V167.52c0-.83-.63-1.05-.63,0v25.34a2,2,0,0,0,2,2h0l.32,0A2,2,0,0,1,260.54,192.86Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
          <path d="M262.59,166.53Z" fill="#f9e9ca" opacity="0.25" />
        </g>
        <path
          d="M263.23,193V167.65c0-.83.63-1.05.63,0V193a2,2,0,0,1-2,2h0a1.73,1.73,0,0,1-.32,0A2,2,0,0,0,263.23,193Z"
          fill="#33667f"
          opacity="0.61"
        />
      </g>
      <g>
        <path
          d="M120,129.89v4.34h-.6c-.34,0-.61-1-.61-2.17s.27-2.17.61-2.17h.6Z"
          fill="#ccbe9e"
        />
        <ellipse cx="120" cy="132.06" rx="0.61" ry="2.17" fill="#3a7599" />
        <path
          d="M122.46,130.85l-.22,2.43h-2c-.16,0-.28-.55-.28-1.22s.12-1.21.28-1.21h2.27Z"
          fill="#295566"
        />
        <path
          d="M120.67,130.6a2.31,2.31,0,0,0,0,2.93h1.53a3.54,3.54,0,0,1,0-2.93Z"
          fill="#3a7599"
        />
        <path
          d="M120.67,133.53s1.47,15.9,10.21,16S141,133.09,141,133.09h-1.4s-2.94,14.87-8.69,14.74-8.68-14.3-8.68-14.3Z"
          fill="#3a7599"
        />
        <path
          d="M124.31,125.23s4.53-3.44,12.32-.76c0,0,2.81,3.57,2.81,7.21s-4,13.79-8.56,14-8.68-10.4-8.68-13.34A11.82,11.82,0,0,1,124.31,125.23Z"
          fill="#33667f"
        />
        <circle cx="130.82" cy="132.38" r="8.36" fill="#295566" />
        <circle cx="130.82" cy="132.38" r="7.91" fill="#90a5b7" />
        <circle
          cx="127.76"
          cy="128.49"
          r="1.66"
          fill="#33667f"
          opacity="0.51"
        />
        <circle
          cx="134.71"
          cy="128.49"
          r="1.66"
          fill="#33667f"
          opacity="0.51"
        />
        <circle cx="127.57" cy="128.49" r="1.66" fill="#2f506a" />
        <path
          d="M125.91,128.49a1.66,1.66,0,1,1,3.32,0"
          fill="none"
          stroke="#20323f"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="0.45"
        />
        <circle cx="127.57" cy="128.49" r="1.15" fill="#20323f" />
        <path
          d="M130.76,135.83a.48.48,0,0,1-.46-.39c-.17-1.07-.5-3.95.9-3.95s1.25,2.83,1.14,3.92a.47.47,0,0,1-.46.42Z"
          fill="#33667f"
          opacity="0.51"
        />
        <circle cx="134.52" cy="128.49" r="1.15" fill="#20323f" />
        <circle cx="134.52" cy="128.49" r="1.66" fill="#275474" />
        <path
          d="M130.38,135.83a.47.47,0,0,1-.46-.39c-.17-1.07-.5-3.95.9-3.95s1.24,2.83,1.14,3.92a.48.48,0,0,1-.47.42Z"
          fill="#2f506a"
        />
        <circle cx="130.82" cy="132.38" r="0.89" fill="#38607a" />
        <circle cx="130.82" cy="132.38" r="0.7" fill="#20323f" />
        <path
          d="M121.18,130.6s.64,1.85-1,1.78a2.89,2.89,0,0,0,.48,1.15h1.53a3.54,3.54,0,0,1,0-2.93Z"
          fill="#33667f"
        />
        <path
          d="M119.33,129.92a3.16,3.16,0,0,0-.51,2.14v.22c.11-.33.3-.65.58-.45,0,0,.06-1.74.57-1.94h-.6Z"
          fill="#f9e9ca"
        />
        <path
          d="M141.61,129.51v4.34h.6c.34,0,.61-1,.61-2.17s-.27-2.17-.61-2.17h-.6Z"
          fill="#ccbe9e"
        />
        <ellipse cx="141.64" cy="131.68" rx="0.61" ry="2.17" fill="#3a7599" />
        <path
          d="M139.18,130.47l.22,2.42h2c.16,0,.29-.54.29-1.21s-.13-1.21-.29-1.21h-2.27Z"
          fill="#295566"
        />
        <path
          d="M141,130.21a2.33,2.33,0,0,1,0,2.94h-1.53a3.56,3.56,0,0,0,0-2.94Z"
          fill="#3a7599"
        />
        <path
          d="M142.32,129.54a3.22,3.22,0,0,1,.5,2.14v.21c-.11-.32-.29-.64-.57-.44,0,0-.07-1.75-.58-1.94h.6Z"
          fill="#f9e9ca"
        />
        <path
          d="M139.73,132.13h0a4.75,4.75,0,0,1-.29,1H141a2.33,2.33,0,0,0,0-2.94h-.51S141.23,132.08,139.73,132.13Z"
          fill="#33667f"
        />
        <path
          d="M130.88,148.53c5.1,0,8.8-11.25,10.08-15.36v0l-1.4,0c-.13.66-3.07,14.84-8.68,14.72s-8.68-14.3-8.68-14.3h-1.53a10.72,10.72,0,0,1,1.79,3.64C123.16,139.53,125.78,148.53,130.88,148.53Z"
          fill="#33667f"
        />
        <g>
          <path
            d="M126,147.45h0l.45.41C126.56,147.86,126.44,147.74,126,147.45Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
          <path
            d="M121,135.83c.52,2.87,1.73,7.77,4.34,10.87-1.75-2.53-2.87-9.11-4.34-10.87Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
        </g>
        <path
          d="M123.3,127c.31-.27.66-.58,1-.92a15.68,15.68,0,0,1,4.23-2.42,10.3,10.3,0,0,0-4.23,1.59A8.06,8.06,0,0,0,123.3,127Z"
          fill="#f9e9ca"
          opacity="0.25"
        />
        <path
          d="M129.65,145.53c-1.88-1.48-5.89-7.56-5.89-7.56h0C125.14,141.22,127.29,144.68,129.65,145.53Z"
          fill="#f9e9ca"
          opacity="0.25"
        />
        <circle cx="134.52" cy="128.49" r="1.15" fill="#20323f" />
        <path
          d="M132.86,128.49a1.66,1.66,0,1,1,3.32,0"
          fill="none"
          stroke="#20323f"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="0.45"
        />
        <path
          d="M130.92,176.87h0a2,2,0,0,1-2-2V149.52c0-1.1.93-1,2-1h0c1.1,0,2-.11,2,1v25.34A2,2,0,0,1,130.92,176.87Z"
          fill="#3a7599"
        />
        <g>
          <path
            d="M129.54,174.86V149.52c0-.83-.63-1.05-.63,0v25.34a2,2,0,0,0,2,2h0l.32,0A2,2,0,0,1,129.54,174.86Z"
            fill="#f9e9ca"
            opacity="0.25"
          />
          <path d="M131.59,148.53Z" fill="#f9e9ca" opacity="0.25" />
        </g>
        <path
          d="M132.23,175V149.65c0-.83.63-1.05.63,0V175a2,2,0,0,1-2,2h0a1.73,1.73,0,0,1-.32,0A2,2,0,0,0,132.23,175Z"
          fill="#33667f"
          opacity="0.61"
        />
      </g>
      <g className="text" transform="translate(-10 -55)">
        <path
          d="M220,244l-.06-.44a1.22,1.22,0,0,0-.23-.59.76.76,0,0,0-.57-.17l-.53,0-.79,0h-.16q-.37,0-1.32.06l-2.08,0v-.86c0-.81,0-1.62.06-2.4s.06-1.42.12-2.11h0c0-.29.05-.58.08-.87q.16-1.69.39-3.21c0-.12,0-.25.05-.37a1.68,1.68,0,0,0,0-.29.85.85,0,0,0-.13-.44.58.58,0,0,0-.49-.26,9.5,9.5,0,0,0-1-.11l-1,0a1.16,1.16,0,0,0-.77.22,1.07,1.07,0,0,0-.29.66c-.16,1.29-.29,2.55-.38,3.81h0c0,.18,0,.35,0,.53v.09c0,.13,0,.25,0,.38-.09,1.28-.13,2.56-.13,3.83s0,2.4.11,3.57a.76.76,0,0,0,.24.54.94.94,0,0,0,.52.2c.55,0,1.08.07,1.61.08l1.58,0c.7,0,1.39,0,2.09-.06l2.18-.15a1.19,1.19,0,0,0,.61-.2.77.77,0,0,0,.25-.54,1.09,1.09,0,0,0,0-.18.45.45,0,0,0,0-.11,2.44,2.44,0,0,0,0-.28C220,244.34,220,244.19,220,244Z"
          fill="#fff"
        />
        <path
          d="M231,237.14a.14.14,0,0,0,0-.06.67.67,0,0,0-.14-.28.74.74,0,0,0-.28-.21,3.14,3.14,0,0,0-.4-.13,6.9,6.9,0,0,0-1-.21,6.53,6.53,0,0,0-.85-.08.49.49,0,0,0-.38.13.79.79,0,0,0-.15.48,4.21,4.21,0,0,0-1.68-.34,4.69,4.69,0,0,0-2,.45,5.67,5.67,0,0,0-.8.45,6.13,6.13,0,0,0-.93.77,6.38,6.38,0,0,0-1.22,1.82,5.51,5.51,0,0,0-.47,2.26,4.48,4.48,0,0,0,.27,1.58,3.58,3.58,0,0,0,.78,1.25,3.52,3.52,0,0,0,1.23.83,4.42,4.42,0,0,0,1.63.29,4.57,4.57,0,0,0,1.54-.26,5,5,0,0,0,1.35-.76,1.43,1.43,0,0,0,.11.62c.08.14.3.24.65.29l.29,0h.75a2.11,2.11,0,0,0,.38,0,1.06,1.06,0,0,0,.7-.3,1.56,1.56,0,0,0,.27-.78c.14-1.17.24-2.38.31-3.65s.09-2.46.09-3.59A2.72,2.72,0,0,0,231,237.14Zm-3.27,3.78c0,.51-.05,1-.08,1.48a3,3,0,0,1-.91.64,2.49,2.49,0,0,1-.95.2,1.66,1.66,0,0,1-1.22-.42,1.51,1.51,0,0,1-.43-1.14,2.33,2.33,0,0,1,.16-.82,2.76,2.76,0,0,1,.47-.81,2.45,2.45,0,0,1,.75-.64,2,2,0,0,1,1-.25,3,3,0,0,1,.69.07,3.47,3.47,0,0,1,.57.19Q227.8,240.16,227.77,240.92Z"
          fill="#fff"
        />
        <path
          d="M241.79,237.65a2.19,2.19,0,0,0-.77-.82l-.17-.09a2.74,2.74,0,0,0-.79-.27,5.16,5.16,0,0,0-.9-.09,5.48,5.48,0,0,0-1.62.25,3.61,3.61,0,0,0-.62.24h0a4.69,4.69,0,0,0-.86.5c0-.1,0-.19,0-.28a1.28,1.28,0,0,0,0-.19v0a.64.64,0,0,0-.09-.36.44.44,0,0,0-.38-.14l-.55,0-.65.05-.62.07a3.57,3.57,0,0,0-.54.09.54.54,0,0,0-.44.39s0,0,0,0a5.5,5.5,0,0,0-.08.69c0,.23,0,.46,0,.69v.68c0,1,0,2,.1,3s.14,2,.25,2.93a1.33,1.33,0,0,0,.23.69,1.05,1.05,0,0,0,.77.26l.29,0H235l.3,0a1.35,1.35,0,0,0,.8-.21.58.58,0,0,0,.2-.49,1.21,1.21,0,0,0,0-.19.88.88,0,0,0,0-.21c-.07-.8-.13-1.59-.18-2.39S236,240.83,236,240a4.65,4.65,0,0,1,1.08-.56,3.13,3.13,0,0,1,1-.18.61.61,0,0,1,.54.27,1.35,1.35,0,0,1,.18.74c0,.78,0,1.44,0,2s0,1-.08,1.33-.05.63-.07.84,0,.39,0,.53a.75.75,0,0,0,.61.83,7.37,7.37,0,0,0,.88.14c.31,0,.56.05.75.05s.54-.09.64-.27a2.08,2.08,0,0,0,.18-.6c.07-.56.14-1.12.2-1.69s.1-1.12.13-1.64.05-1,.07-1.48,0-.85,0-1.19A2.86,2.86,0,0,0,241.79,237.65Z"
          fill="#fff"
        />
        <path
          d="M253.17,238.94c0-.17,0-.33,0-.48h0c0-.29,0-.54,0-.76a2.48,2.48,0,0,0-.08-.55,1.2,1.2,0,0,0-.18-.34.78.78,0,0,0-.29-.21,2.35,2.35,0,0,0-.4-.13l-.4-.1h0l-.65-.11a7.42,7.42,0,0,0-.82-.08.45.45,0,0,0-.33.11.66.66,0,0,0-.09.15,1.44,1.44,0,0,0-.05.24,3.79,3.79,0,0,0-.69-.16l-.34,0h-.36a2.92,2.92,0,0,0-.51,0h0a4.68,4.68,0,0,0-1.44.39l-.25.13h0a6,6,0,0,0-1.48,1,5.8,5.8,0,0,0-1.23,1.76A5.16,5.16,0,0,0,243,242a4.08,4.08,0,0,0,.27,1.5,3.43,3.43,0,0,0,.77,1.22,3.62,3.62,0,0,0,1.22.81,4.44,4.44,0,0,0,1.64.29,4.52,4.52,0,0,0,2.86-1c0,.47-.08.92-.13,1.36s-.11.85-.17,1.24a15.62,15.62,0,0,1-1.79-.12,8.8,8.8,0,0,1-1.76-.43,1.47,1.47,0,0,0-.48-.11.4.4,0,0,0-.28.1,1.26,1.26,0,0,0-.23.32c-.11.25-.23.53-.34.84a2.43,2.43,0,0,0-.17.73.64.64,0,0,0,.18.47,1.7,1.7,0,0,0,.45.31,11.49,11.49,0,0,0,2.19.73,11.08,11.08,0,0,0,2.42.24,3.8,3.8,0,0,0,1.15-.17,3.6,3.6,0,0,0,.92-.46,2.71,2.71,0,0,0,.65-.66,2.08,2.08,0,0,0,.34-.8c.08-.48.16-1,.22-1.67s.12-1.3.16-2,.06-1.41.08-2.13,0-1.41,0-2.07S253.18,239.42,253.17,238.94Zm-3.25,2.18c0,.36,0,.73,0,1.11a2.71,2.71,0,0,1-1.82.76,1.7,1.7,0,0,1-1.21-.41,1.42,1.42,0,0,1-.44-1.09,2.22,2.22,0,0,1,.16-.79,2.67,2.67,0,0,1,.47-.79,2.48,2.48,0,0,1,.75-.6,2,2,0,0,1,1-.25,3.64,3.64,0,0,1,.6.05,2.44,2.44,0,0,1,.5.14Z"
          fill="#fff"
        />
        <path
          d="M263.89,241.26c0-.33,0-.66-.05-1-.06-1-.14-2-.25-2.94a.81.81,0,0,0-.31-.65,1.54,1.54,0,0,0-.81-.16,4.14,4.14,0,0,0-.58,0l-.54.11a1.77,1.77,0,0,0-.78.36.83.83,0,0,0-.2.59c0,.11,0,.32,0,.63s.07.69.1,1.12,0,.61.06,1l0,.5c0,.53,0,1.08,0,1.67a4.52,4.52,0,0,1-1.09.56,3.23,3.23,0,0,1-1,.18A.61.61,0,0,1,258,243a1.32,1.32,0,0,1-.18-.73c0-.49,0-1,.05-1.49s.05-.76.08-1.11c0-.09,0-.19,0-.28,0-.42.08-.79.11-1.12s.05-.55.05-.69A.84.84,0,0,0,258,237a.88.88,0,0,0-.46-.3,3.18,3.18,0,0,0-.59-.15,4.73,4.73,0,0,0-.65,0,1.91,1.91,0,0,0-.92.17.93.93,0,0,0-.39.72c-.06.47-.12,1-.16,1.43l0,.26c-.06.57-.11,1.11-.14,1.64s0,1-.07,1.47,0,.86,0,1.2a2.86,2.86,0,0,0,.31,1.45,2.35,2.35,0,0,0,.77.82,2.8,2.8,0,0,0,1,.36,6.11,6.11,0,0,0,.9.08,5.59,5.59,0,0,0,1.63-.24,5.4,5.4,0,0,0,1.48-.74,2,2,0,0,1,0,.26c0,.08,0,.15,0,.23,0,.39.23.59.69.59a6,6,0,0,0,1-.1,4.55,4.55,0,0,0,1.1-.3.66.66,0,0,0,.43-.42,3.77,3.77,0,0,0,.1-.72c0-.23,0-.46,0-.68v-.71C263.94,242.61,263.92,241.93,263.89,241.26Z"
          fill="#fff"
        />
        <path
          d="M275.32,237.14a.83.83,0,0,0-.16-.34.86.86,0,0,0-.29-.21,2.69,2.69,0,0,0-.4-.13,6.76,6.76,0,0,0-1-.21,6.66,6.66,0,0,0-.86-.08.51.51,0,0,0-.38.13.79.79,0,0,0-.15.48,4.16,4.16,0,0,0-1.67-.34,4.66,4.66,0,0,0-2,.45,5.49,5.49,0,0,0-1.73,1.22,6.21,6.21,0,0,0-1.23,1.82,5.27,5.27,0,0,0-.43,1.67,5.83,5.83,0,0,0,0,.59,4.72,4.72,0,0,0,.26,1.58,3.58,3.58,0,0,0,.78,1.25,3.47,3.47,0,0,0,1.24.83,4.39,4.39,0,0,0,1.63.29,4.61,4.61,0,0,0,1.54-.26,4.82,4.82,0,0,0,1.34-.76,1.28,1.28,0,0,0,.12.62c.07.14.29.24.64.29l.3,0h.75a2.22,2.22,0,0,0,.38,0,1,1,0,0,0,.69-.3,1.56,1.56,0,0,0,.28-.78l0-.29c.12-1.08.21-2.19.27-3.36s.09-2.46.09-3.59A2.81,2.81,0,0,0,275.32,237.14Zm-4.9,6.08-.31,0a1.68,1.68,0,0,1-1.23-.42.44.44,0,0,1-.09-.11,1.52,1.52,0,0,1-.34-1,2.36,2.36,0,0,1,.17-.82,2.73,2.73,0,0,1,.46-.81,2.45,2.45,0,0,1,.75-.64,2,2,0,0,1,1-.25,2.84,2.84,0,0,1,.68.07,3.47,3.47,0,0,1,.57.19q0,.74-.06,1.5c0,.51-.05,1-.07,1.48a3,3,0,0,1-.92.64,2.42,2.42,0,0,1-.62.18Z"
          fill="#fff"
        />
        <path
          d="M286.72,238.94c0-.49,0-.91-.06-1.25a2.48,2.48,0,0,0-.08-.55,1.2,1.2,0,0,0-.18-.34.86.86,0,0,0-.29-.21,2.69,2.69,0,0,0-.4-.13,8,8,0,0,0-1.06-.21,7.42,7.42,0,0,0-.82-.08.45.45,0,0,0-.33.11.65.65,0,0,0-.14.39,3.7,3.7,0,0,0-.7-.16,5.09,5.09,0,0,0-.69,0,4.79,4.79,0,0,0-2,.43,5.72,5.72,0,0,0-3,2.92,5.16,5.16,0,0,0-.47,2.17,4.08,4.08,0,0,0,.27,1.5,3.29,3.29,0,0,0,.77,1.22,3.62,3.62,0,0,0,1.22.81,4.42,4.42,0,0,0,1.63.29,4.55,4.55,0,0,0,2.87-1c0,.47-.08.92-.13,1.36s-.09.68-.13,1c0,.09,0,.17,0,.25a16,16,0,0,1-1.8-.12,8.72,8.72,0,0,1-1.75-.43,1.47,1.47,0,0,0-.48-.11.39.39,0,0,0-.28.1,1.26,1.26,0,0,0-.23.32c-.11.25-.23.53-.34.84a2.16,2.16,0,0,0-.17.73.64.64,0,0,0,.18.47,1.82,1.82,0,0,0,.44.31,11.81,11.81,0,0,0,2.2.73,11.08,11.08,0,0,0,2.42.24,3.85,3.85,0,0,0,1.15-.17,3.77,3.77,0,0,0,.92-.46,2.71,2.71,0,0,0,.65-.66,2.06,2.06,0,0,0,.33-.8,2,2,0,0,1,.05-.24c.07-.42.13-.9.18-1.43s.11-1.3.15-2,.07-1.41.09-2.13,0-1.41,0-2.07S286.73,239.42,286.72,238.94ZM281.63,243a1.75,1.75,0,0,1-1.22-.41,1.41,1.41,0,0,1-.43-1.09,2.22,2.22,0,0,1,.16-.79,2.86,2.86,0,0,1,.46-.79,2.76,2.76,0,0,1,.75-.6,2,2,0,0,1,1-.25,3.73,3.73,0,0,1,.6.05,2.44,2.44,0,0,1,.5.14v1.87c0,.36,0,.73,0,1.11A2.73,2.73,0,0,1,281.63,243Z"
          fill="#fff"
        />
        <path
          d="M297.3,239.48a4.4,4.4,0,0,0-2.22-2.58,3.91,3.91,0,0,0-1.39-.42,5.36,5.36,0,0,0-.82-.06,5,5,0,0,0-1.87.36,4.92,4.92,0,0,0-1.59,1,5,5,0,0,0-1.09,1.56,4.9,4.9,0,0,0-.41,2,4.72,4.72,0,0,0,.4,1.95,4.79,4.79,0,0,0,1.06,1.5,4.54,4.54,0,0,0,1.52,1l.36.13a4.9,4.9,0,0,0,1.43.21,7.72,7.72,0,0,0,2.33-.33,4.05,4.05,0,0,0,1.6-.88.88.88,0,0,0,.3-.65v-.18a.81.81,0,0,0,0-.2l-.09-.42a3.71,3.71,0,0,0-.12-.41,1.35,1.35,0,0,0-.16-.32.25.25,0,0,0-.22-.1,1.21,1.21,0,0,0-.4.13,5,5,0,0,1-1.22.41,5.26,5.26,0,0,1-1.15.14,3.2,3.2,0,0,1-1.27-.25l-.1-.05a2.76,2.76,0,0,1-.88-.65c.35,0,.71,0,1.08-.07l.51,0c.55-.06,1.08-.12,1.59-.2s1-.16,1.46-.26a10.68,10.68,0,0,0,1.16-.33.7.7,0,0,0,.38-.3,1,1,0,0,0,.09-.42A4.17,4.17,0,0,0,297.3,239.48Zm-4.44.83-.14,0-1.81.12a2,2,0,0,1,.78-1,2.08,2.08,0,0,1,1.24-.4l.23,0a1.93,1.93,0,0,1,.65.22,1.4,1.4,0,0,1,.65.79A10.57,10.57,0,0,1,292.86,240.31Z"
          fill="#fff"
        />
        <path
          d="M315.77,240.77a.65.65,0,0,0-.69-.55h-.16l-.26,0-.47,0c-.54-1.54-1.09-2.93-1.64-4.2-.29-.67-.56-1.26-.81-1.79s-.42-.9-.61-1.27a1.13,1.13,0,0,0-.91-.64c-.11,0-.24,0-.38,0h-.47a8.68,8.68,0,0,0-1,.06,8.23,8.23,0,0,0-1,.15,1.19,1.19,0,0,0-.85.74q-.24.59-.48,1.2c-.29.71-.59,1.46-.88,2.23-.46,1.2-.89,2.43-1.3,3.67-.4,0-.69-.06-.85-.06a.74.74,0,0,0-.44.13.62.62,0,0,0-.25.44,5.28,5.28,0,0,0-.06.74c0,.28,0,.58,0,.91a.69.69,0,0,0,0,.25.58.58,0,0,0,.26.32,1.24,1.24,0,0,0,.46.15l-.09.31-.15.58c-.07.28-.12.53-.16.73s0,.21-.05.26a.71.71,0,0,0,0,.14.61.61,0,0,0,.48.62,8.53,8.53,0,0,0,1.15.27,6.73,6.73,0,0,0,.93.1h.23a.68.68,0,0,0,.74-.64q.1-.5.21-1c.08-.35.16-.7.25-1.07l1.36.06,1.39,0c.74,0,1.46,0,2.18-.06l.54,2a1.11,1.11,0,0,0,.26.51.78.78,0,0,0,.51.16,7.12,7.12,0,0,0,1.23-.11,11.06,11.06,0,0,0,1.17-.27.58.58,0,0,0,.45-.61.76.76,0,0,0,0-.14,3,3,0,0,0-.06-.32l-.18-.69c-.07-.26-.15-.53-.24-.82a.92.92,0,0,0,.49-.19.88.88,0,0,0,.23-.54,1.24,1.24,0,0,0,0-.33v-.31A4.6,4.6,0,0,0,315.77,240.77Zm-6.82-.34h-1.56c.22-.72.45-1.46.69-2.2s.5-1.5.77-2.28q.48,1,.9,2.16c.28.76.53,1.53.78,2.3Z"
          fill="#fff"
        />
        <path
          d="M324.08,238.65a5.51,5.51,0,0,0-.11-1,2.58,2.58,0,0,0-.38-.89.92.92,0,0,0-.8-.42,3.45,3.45,0,0,0-1.41.29,4.24,4.24,0,0,0-1.19.76l0-.3c0-.1,0-.2,0-.27a.64.64,0,0,0-.1-.36.44.44,0,0,0-.38-.14l-.55,0-.64.05-.63.07a3.42,3.42,0,0,0-.53.09.56.56,0,0,0-.45.39,4.51,4.51,0,0,0-.08.73c0,.23,0,.46,0,.69v.68q0,1.48.09,3c.07,1,.15,2,.25,2.93a1.43,1.43,0,0,0,.24.69,1,1,0,0,0,.77.26l.28,0h.66l.29,0a1.41,1.41,0,0,0,.81-.21.6.6,0,0,0,.2-.49c0-.1,0-.31-.05-.62s-.07-.69-.1-1.15-.06-1-.09-1.6-.05-1.24-.05-1.93a5.57,5.57,0,0,1,.54-.39l.49-.27a4.16,4.16,0,0,1,.07.59c0,.22,0,.41,0,.55a1.19,1.19,0,0,0,.17.6.56.56,0,0,0,.5.27,1.92,1.92,0,0,0,.6-.14,5.73,5.73,0,0,0,.63-.28,2,2,0,0,0,.73-.61,1.3,1.3,0,0,0,.2-.7C324.1,239.3,324.09,239,324.08,238.65Z"
          fill="#fff"
        />
        <path
          d="M330.86,237.57a.85.85,0,0,0-.53-.24c-.23,0-.46-.06-.68-.08l-.65-.07c0-.23,0-.47,0-.73l0-.75c0-.24,0-.45,0-.62s0-.28,0-.35a1,1,0,0,0-.17-.63.72.72,0,0,0-.61-.22A9.84,9.84,0,0,0,327,234a2.21,2.21,0,0,0-.77.23.71.71,0,0,0-.35.4,2,2,0,0,0-.11.61c0,.28,0,.53,0,.78s0,.48,0,.72v.53a5.21,5.21,0,0,0-.6.08.76.76,0,0,0-.36.17.58.58,0,0,0-.19.3,2.39,2.39,0,0,0,0,.51c0,.1,0,.22,0,.36a3,3,0,0,0,0,.42.81.81,0,0,0,.21.58,1.24,1.24,0,0,0,.58.18l.5.06c.06.93.13,1.84.21,2.71s.19,1.76.32,2.66a1,1,0,0,0,.24.62.83.83,0,0,0,.54.16,8.75,8.75,0,0,0,1.44-.12.83.83,0,0,0,.54-.22.79.79,0,0,0,.14-.52c0-.12,0-.39,0-.79s0-.86-.07-1.37-.06-1-.09-1.58,0-1,0-1.44l.44,0a4.8,4.8,0,0,0,.56-.06,1.13,1.13,0,0,0,.61-.18.82.82,0,0,0,.27-.52c0-.18,0-.37.06-.58s0-.37,0-.5A.87.87,0,0,0,330.86,237.57Z"
          fill="#fff"
        />
        <path
          d="M336.41,239.68a.82.82,0,0,0,.49.22A6.29,6.29,0,0,0,338,240a.67.67,0,0,0,.52-.16,1.35,1.35,0,0,0,.23-.45,6.57,6.57,0,0,0,.18-.87,5.36,5.36,0,0,0,.09-.91.87.87,0,0,0-.16-.58,1,1,0,0,0-.47-.3,8.53,8.53,0,0,0-1.3-.32,9.51,9.51,0,0,0-1.39-.11,5.65,5.65,0,0,0-1.59.22,4.68,4.68,0,0,0-1.36.6,3.26,3.26,0,0,0-1,1,2.21,2.21,0,0,0-.37,1.25,2.35,2.35,0,0,0,.29,1.22,3,3,0,0,0,.73.85,4.07,4.07,0,0,0,.95.59l.95.42a6.34,6.34,0,0,1,.73.35c.2.12.3.24.3.38a.35.35,0,0,1-.27.36,2,2,0,0,1-.7.1,3.75,3.75,0,0,1-.68-.08,2.88,2.88,0,0,1-.75-.25,1.6,1.6,0,0,0-.49-.15c-.14,0-.27.14-.4.4a5.87,5.87,0,0,1-.24.56,4.62,4.62,0,0,0-.21.58,1.62,1.62,0,0,0-.06.4.67.67,0,0,0,.51.63,5.82,5.82,0,0,0,1.21.33,8.83,8.83,0,0,0,1.43.1,6.24,6.24,0,0,0,1.66-.2,4.24,4.24,0,0,0,1.33-.57,2.84,2.84,0,0,0,.88-.88,2.1,2.1,0,0,0,.33-1.16,2.26,2.26,0,0,0-.33-1.25,2.89,2.89,0,0,0-.81-.86,5.3,5.3,0,0,0-1.07-.59c-.38-.16-.73-.3-1.06-.42a7.74,7.74,0,0,1-.82-.35c-.21-.12-.32-.24-.32-.38a.47.47,0,0,1,.33-.46,2.26,2.26,0,0,1,.83-.13,2.88,2.88,0,0,1,.61.09v.14A1.1,1.1,0,0,0,336.41,239.68Z"
          fill="#fff"
        />
      </g>
    </g>
  );
};
export default LanguageArtsLink;
